import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import FontAwesome from 'react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolderOpen, faFolder } from '@fortawesome/free-solid-svg-icons';
import './tableGridGroups.css';
import {Button } from "reactstrap";
import {active, labels, messages} from "../../util/constants";
import renderIf from "render-if";

let propsG = [];

const cellEditProp = {
    mode: 'click'
};

const options = {
    sortName: ['group_name_pt'], //TODO VERIFICAR IDIOMA
    sortOrder: ['asc'],
};

const getIcons = (cell,row)=>{
    if(cell == active){//active
        return  (<div title={labels.active} className={'icon-user-active'}><FontAwesomeIcon icon={faFolderOpen} /></div>);
    }else{
        return  (<div title={labels.inactive} className={'icon-user-inactive'}><FontAwesomeIcon icon={faFolder} /></div>);
    }
};

const setLinkToEdit = (cell,row)=>{
    if(row.group_inactive == active){
        return <div className={'pointer'} onClick={()=>{propsG.redirectToEditItemsGroup(row)}}>{ cell }</div>;
    }else{
        return cell;
    }

};

const getButton = (cell,row)=>{
    return (
        <div>
            <Button title={labels.editGroup} color="link" className={'btn-edit'} onClick={()=>{propsG.redirectToEditGroup(row)}}><FontAwesome name={'edit'}/></Button>
            {
                renderIf(row.group_inactive == active)
                (
                    <Button title={labels.removeGroup} color="link" className={'btn-cancel'} onClick={()=>{propsG.disableGroup(row.id_group)}}><FontAwesome name={'times-circle'}/></Button>
                )
            }
        </div>);
};

const TableGridGroups = (props) => {
    propsG = props;
    return(
        <div className="div-margin-top col-15">
                <h6 className={'title-table'}>{messages.selectGroupToAddNewInfo}</h6>
                <BootstrapTable width data={props.data} options={options} cellEdit={ cellEditProp }  multiColumnSort={1} striped hover
                                condensed pagination >
                    <TableHeaderColumn dataField="group_name_pt" width='70%' editable={false} isKey dataFormat={setLinkToEdit}
                                       dataAlign='left' dataSort> {labels.cstGroups} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="group_inactive"  editable={false} dataFormat={getIcons}
                                        dataAlign='center'> {labels.status} </TableHeaderColumn>
                    <TableHeaderColumn  dataField="actions"  editable={false} dataFormat={getButton}
                                        dataAlign='center'> {labels.action} </TableHeaderColumn>

                </BootstrapTable>

        </div>

    );
}

export default TableGridGroups;


// WEBPACK FOOTER //
// ./src/components/TableGridGroups/tableGridGroups.js